import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    mainWrapper: {
        display: "flex",
        flexDirection: "column",
        textAlign: "left",
        marginTop: 64,
        fontFamily: "Source Sans 3",
        backgroundColor: theme.palette.backgrounds.main,
        minHeight: "calc(100vh - 64px)",
    },
    mainWrapperLoading: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "30px 22px",
        fontFamily: "Source Sans 3",
        backgroundColor: theme.palette.backgrounds.main,
        minHeight: "calc(100vh - 64px)",
    },
    textLoading: {
        fontFamily: "Source Sans 3",
        fontSize: "14px",
        fontWeight: 600,
        color: theme.palette.text.primary,
        marginTop: 16,
    },
    mainTitle: {
        fontSize: "24px",
        fontWeight: 400,
        color: theme.palette.text.primary,
        marginBottom: 30,
        padding: "30px 22px 0px 22px",
    },
    tabs: {
        // Cedar rebrand: breathing room between the fixed top bar and the pill row.
        padding: "24px 22px 0px 22px",
        "&.MuiTabs-root .MuiTabs-scroller .MuiTabs-indicator": {
            borderBottom: "none",
            backgroundColor: "transparent",
        },
        "&.MuiTabs-root .MuiTabs-scroller .MuiTabs-flexContainer .MuiButtonBase-root": {
            fontFamily: "Source Sans 3",
            fontWeight: 400,
            fontSize: "14px",
            color: theme.palette.corporateBO.tabText,
            textTransform: "none",
            padding: 0,
            minWidth: 0,
        },
        "&.MuiTabs-root .MuiTabs-scroller .MuiTabs-flexContainer .Mui-selected": {
            fontFamily: "Source Sans 3",
            fontWeight: 600,
            fontSize: "14px",
            color: theme.palette.corporateBO.tabText,
            textTransform: "none",
            borderBottom: `3px solid ${theme.palette.border.tabs}`,
        },
        "&.MuiTabs-root .MuiTabs-scroller .MuiTabs-flexContainer": {
            gap: theme.spacing(6),
        },
    },
    tabComponentWrapper: {
        marginTop: 16,
    },
    tabComponentWrapperFullscreen: {
        marginTop: 0,
    },
}));
